import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchSchedules({ service_provider_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/list_schedules/${service_provider_id}`
    );
  },
};
